<template>
  <div>
    <b-container class="p-0">
      <b-row>
        <b-col cols="9" class="pr-1">
          <ReachDecimalInput
              ref="base"
              :formField="validatedField"
              :field-config="fieldConfig"
              :read-only="readOnly"
              :editor-mode="editorMode"
              :label="fieldLabel"
              :hint="fieldConfig.shortHelpText"
              :help-title="fieldConfig.helpWindowTitle"
              :help-message="fieldConfig.htmlHelpText"
              :initialFocus="fieldConfig.autofocus"
              :min="fieldConfig.min"
              :max="fieldConfig.max"
              :step="fieldConfig.step"
              :placeholder="fieldConfig.formPlaceholder"
              :allow-null="fieldConfig.allowNull"
              :with-select="withSelect"
              data-type="DecimalWithCurrency"
              @input="emitInput"
              :grid-editor="gridEditor"
              :open-from-grid="openFromGrid"
              :mode="mode"
              :currency="currency"
          >
          </ReachDecimalInput>
        </b-col>
        <b-col cols="3" class="pl-0">
          <b-form-group>
            <slot name="label" v-if="!onlyInputVisible">
              &nbsp
            </slot>
            <b-form-select
                v-model="currency"
                ref="input"
                @change="currencyRefresh"
                :disabled="readOnly"
                :class="readOnly ? 'grey-label' : ''"
                :options="currencies">
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import DecimalFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig";
import DecimalWithCurrency from "@/server/com/silkplm/rpc/dto/DecimalWithCurrency";
import ReachDecimalInput from "@/components/inputs/ReachDecimalInput";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";
import CacheManager from "@/components/cacheManager/CacheManager";
import {cloneEntity} from "@/utils/Objects";
import ValueAttribute from "@/server/com/silkplm/model/plm/ValueAttribute";

export default {
  name: "DecimalCurrencyRenderer",
  components: {ReachDecimalInput},
  created() {
  },

  async mounted() {
    this.fieldLabel = this.fieldConfig.fieldLabel;
    let currencies = await CacheManager.getDictionary(Currency.getRemoteClass());
    if (currencies) {
      this.currencies.push({value: null, text: ""});
      for (const value of currencies) {
        this.currencyById.set("" + value.id, value);
        this.currencies.push({value: "" + value.id, text: value.name});
      }
      if (this.mode === "NEW") {
        if (this.fieldConfig.defaultCurrency) {
          let systemCurrency = await Rpc.plm.services.CompanyConfigurationService.findSystemCurrency();
          if (systemCurrency) {
            let defaultCurrency = _.find(currencies, {id: systemCurrency.id});
            if (defaultCurrency) {
              this.currency = "" + defaultCurrency.id;
              this.validatedField.value = new DecimalWithCurrency();
              this.validatedField.value.currency = systemCurrency
            }
          }
        }
      }
    }

    if (this.validatedField?.validatedForm?.originalSource instanceof ValueAttribute) {
      if (this.validatedField?.value?.currency?.id) {
        this.currency = "" + this.validatedField.value.currency.id;
      }
    } else if (this.openFromGrid) {
      if (this.validatedField?.value?.currency?.id) {
        this.currency = "" + this.validatedField.value.currency.id;
        this.initializeCurrencies(this.validatedField.value.currency);
      }
    } else {
      this.validatedField.validatedForm.onLoaded(() => {
        if (this.validatedField?.value?.currency?.id) {
          this.currency = "" + this.validatedField.value.currency.id;
          this.initializeCurrencies(this.validatedField.value.currency);
        }
      });
    }
  },

  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: DecimalFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
    mode: {default: null}
  },

  methods: {
    initializeCurrencies(currency) {
      this.updateInProgress = true;
      if (this.currencyById.has("" + currency.id)) {
      } else {
        this.currencies.push({value: "" + currency.id, text: currency.name});
        this.currencyById.set("" + currency.id, currency);
      }
      this.updateInProgress = false;
    },

    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    emitInput() {
      setTimeout(() => {
        this.$emit('input', this.validatedField.value);
      })
    },

    currencyRefresh() {
      this.currency = "" + this.$refs.input.$el.value;
      this.updateCurrency(this.currency);
      this.emitInput();
    },
    updateCurrency(val) {
      // console.log("Currency updated");
      if (this.updateInProgress) {
        return;
      }
      this.updateInProgress = true;
      try {
        if (!this.validatedField.value && this.readOnly === false) {
          this.validatedField.value = new DecimalWithCurrency();
          this.validatedField.value.currency = this.currencyById.get("" + this.currency);
          this.validatedField.notify();
        } else if (this.readOnly === false) {
          this.validatedField.value.currency = this.currencyById.get("" + this.currency);
          this.validatedField.notify();
        }
      } finally {
        this.updateInProgress = false;
      }
    }
  },

  watch: {

    "validatedField.value.decimal": function (val) {
      this.$refs.base.$refs.base.afterChangeVal(this.validatedField.value);
    },

    "validatedField.value.currency": function (val) {
      if (this.fieldConfig.fieldName === "retailPriceInitial") {
        let x = 5;
      }
      if (this.updateInProgress) {
        return;
      }
      this.updateInProgress = true;
      try {
        if (val?.id) {
          this.currency = "" + val.id;

          if (this.currencyById.has("" + val.id)) {
            this.currency = "" + val.id;
          } else {
            this.currency = "" + val.id;
            this.currencies.push({value: "" + val.id, text: val.name});
            this.currencyById.set("" + val.id, val);
          }

        } else {
          this.currency = "" + val;
        }
      } finally {
        this.updateInProgress = false;
        this.$refs.base.$refs.base.afterChangeVal(this.validatedField.value);
      }
    },

    "validatedField.value": function (newVal, oldVal) {
      this.updateInProgress = true;
      if (newVal?.currency && newVal.currency.name != null) {
        if (this.currencyById.has("" + newVal.currency.id)) {
          this.currency = "" + newVal.currency.id;
        } else {
          this.currency = "" + newVal.currency.id;
          this.currencies.push({value: "" + newVal.currency.id, text: newVal.currency.name});
          this.currencyById.set("" + newVal.currency.id, newVal.currency);
        }
      }
      this.updateInProgress = false;
    },

    currency: function (val) {
      this.updateCurrency(val);
    },
  },

  data: function () {
    return {
      onlyInputVisible: this.validatedField?.__hideHints,
      updateInProgress: false,
      currencies: [],
      readOnly: true,
      editorMode: false,
      currencyById: new Map(),
      currency: null,
      fieldLabel: "",
      withSelect: true
    }
  }
}
</script>

